import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { useDispatch, useSelector } from "react-redux";
import DanhSachTaiSanApi from "../../../../service/danhSachTaiSanApi";
import { currentDate } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import StoreApi from "../../../../service/storeApi";
import userApi from "../../../../service/userApi";
import { pushNotification } from "utils/notifications";
import {
  getListTaiSan,
  updateDataSearch,
} from "../../../../actions/DanhSachTaiSan/";
import { DanhSachTaiSanCombo } from "../../../../constants/danhSachTaiSanConst";
import { formatDayMonth } from "utils/formatDate";
import DateTimePicker from "../../../../components/GenericComponent/DateTimePicker";
import { convertDate } from "utils/formatDate";
import { Controller } from "react-hook-form";
import { useForm } from "react-hook-form";
import { formatNumber } from "utils/currencyFormat";
import UploadCustomerImage from "../../../../components/GenericComponent/UploadCustomerImage";
import ChiTietCuaHangApi from "service/chiTietCuaHangApi";
import UploadAnhKhachHang from "./UploadAnhKhachHang";

export const ChoThue = (props) => {
  const currentForm = useForm();
  const { register, control } = currentForm;
  //Code upload 1 ảnh
  const [photo, setPhoto] = React.useState(null);

  // const handleChoosePhoto = () => {
  //   launchImageLibrary({ noData: true }, (response) => {
  //     if (response) {
  //       setPhoto(response);
  //     }
  //   });
  // };

  // const handleUploadPhoto = () => {
  //   fetch(`${SERVER_URL}/api/upload`, {
  //     method: "POST",
  //     body: createFormData(photo, { userId: "123" }),
  //   })
  //     .then((response) => response.json())
  //     .then((response) => {
  //     })
  //     .catch((error) => {
  //     });
  // };
  //End-Code upload 1 ảnh
  const [nameCode, setNameCode] = React.useState("");
  const [text, onChangeText] = useState(false);
  const dataOption = {
    nguoiTaoOption: [
      {
        label: "Nguyễn Thị Thu Hằng",
        value: "Nguyễn Thị Thu Hằng",
      },
      {
        label: "Trần Văn B",
        value: "Trần Văn B",
        selected: true,
      },
    ],
    khoOption: [
      {
        label: "Kho 1",
        value: "Kho 1",
        selected: true,
      },
      {
        label: "Kho 2",
        value: "Kho 2",
      },
    ],
  };

  //Code
  const dataSearch = useSelector((state) => state.dataSearchTaiSan);
  const dispatch = useDispatch();
  const initData = {
    DuongDanAnh: "",
    HoTen: "",
    SoDienThoai: "",
    DiaChi: "",
    CMND: "",
    NgayMuon: currentDate(),
    NgayTra: currentDate(),
    NguoiTao: "",
    KhachHang_GhiChu: "",
    TaiSanId: "",
    PhiThue: "",
    TaiSan_GhiChu: "",
  };

  const [dataChoThue, setDataChoThue] = useState(initData);
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);
  const [dataUser, setdataUser] = useState(dataOption.nguoiTaoOption);

  const updateDropdown = (field) => (e) => {
    setDataChoThue({
      ...dataChoThue,
      [field]: e.target.value,
    });
    if (e.target.value === "" || e.target.value === "0") {
      setErrors5({
        ...errors5,
        nguoiTao: "Chọn người tạo",
      });
    } else {
      setErrors5({
        ...errors5,
        nguoiTao: "",
      });
    }
  };

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataChoThue({
      ...dataChoThue,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        hoTen: "Nhập tên",
      });
      setErrors1({
        ...errors1,
        soDienThoai: "Nhập số điện thoại",
      });
    } else {
      setErrors({
        ...errors,
        hoTen: "",
      });
      setErrors1({
        ...errors1,
        soDienThoai: "",
      });
    }
  };
  const onChangeNumber = (field) => (evt) => {
    setDataChoThue({
      ...dataChoThue,
      [field]: convertToNumber(evt.target.value),
    });
    if (evt.target.value === "") {
      setErrors4({
        ...errors4,
        phiThue: "Nhập tiền",
      });
    } else if (evt.target.value === 0) {
      setErrors4({
        ...errors4,
        phiThue: "Nhập tiền",
      });
    } else {
      setErrors4({
        ...errors4,
        phiThue: "",
      });
    }
  };

  const onChangeDate = (field) => (evt) => {
    setDataChoThue({
      ...dataChoThue,
      [field]: formatDayMonth(evt),
    });
    if (evt === "null") {
      setErrors3({
        ...errors3,
        ngayTra: "Nhập ngày tra",
      });
      setErrors2({
        ...errors2,
        ngayMuon: "Nhập ngày mượn",
      });
    } else {
      setErrors3({
        ...errors3,
        ngayTra: "",
      });
      setErrors2({
        ...errors2,
        ngayMuon: "",
      });
    }
  };

  const [listUser, setListUser] = useState(dataOption.nguoiTaoOption);
  useEffect(() => {
    StoreApi.combo({}).then((response) => {
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      setdataCombo(dataComboReturn);

      DanhSachTaiSanApi.getOneDetailTaiSan(props.TaiSanID).then((response) => {
        setDataChoThue({
          ...dataChoThue,
          Code: response.data.ThongTinTaiSan.Code,
          TenTaiSan: response.data.ThongTinTaiSan.TenTaiSan,
          Status: response.data.ThongTinTaiSan.Status,
          StoreName: response.data.ThongTinTaiSan.StoreName,
          TaiSanId: response.data.ThongTinTaiSan.TaiSanId,
        });
      });
    });
    // lồng vào trong StoreApi (kho id) để lấy giá trị lúc đầu của kho
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });

    ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
      setNameCode(response.data.Code);
    });
  }, []);

  const onChangeImg = () => (Img) => {
    setDataChoThue({
      ...dataChoThue,
      DuongDanAnh: Img,
    });
  };

  //Alret

  const validateName = (HoTen) => {
    const expression = /(\w.).+/i;
    const wordCount = HoTen.trim().split(/\s+/).length;
    if (wordCount < 2) {
      return false;
    }
    return expression.test(String(HoTen).toLowerCase());
  };

  //Thông báo
  const initErrors = {
    hoTen: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const initErrors1 = {
    soDienThoai: "",
  };
  const [errors1, setErrors1] = useState(initErrors1);
  const initErrors2 = {
    ngayMuon: "",
  };
  const [errors2, setErrors2] = useState(initErrors2);
  const initErrors3 = {
    ngayTra: "",
  };
  const [errors3, setErrors3] = useState(initErrors3);
  const initErrors4 = {
    phiThue: "",
  };
  const [errors4, setErrors4] = useState(initErrors4);
  const initErrors5 = {
    nguoiTao: "",
  };
  const [errors5, setErrors5] = useState(initErrors5);
  const onSubmit = () => {
    if (dataChoThue.HoTen === "") {
      setErrors({
        ...errors,
        hoTen: "Nhập tên",
      });
      return;
    } else if (!validateName(dataChoThue.HoTen)) {
      setErrors({
        ...errors,
        hoTen: "Họ tên phải có ít nhất 2 từ",
      });
      return;
    } else if (dataChoThue.SoDienThoai === "") {
      setErrors1({
        ...errors1,
        soDienThoai: "Nhập số điện thoại",
      });
      return;
    } else if (
      dataChoThue.NgayMuon === "null" ||
      dataChoThue.NgayMuon === null ||
      dataChoThue.NgayMuon === ""
    ) {
      setErrors2({
        ...errors2,
        ngayMuon: "Nhập ngày mượn",
      });
      return;
    } else if (
      dataChoThue.NgayTra === "null" ||
      dataChoThue.NgayTra === null ||
      dataChoThue.NgayTra === ""
    ) {
      setErrors3({
        ...errors3,
        ngayTra: "Nhập ngày tra",
      });
      return;
    } else if (dataChoThue.PhiThue === 0 || dataChoThue.PhiThue === "") {
      setErrors4({
        ...errors4,
        phiThue: "Nhập tiền",
      });
      return;
    } else if (
      dataChoThue.NguoiTao === listUser[0].value ||
      dataChoThue.NguoiTao === ""
    ) {
      setErrors5({
        ...errors5,
        nguoiTao: "Chọn người tạo",
      });
      return;
    }
    DanhSachTaiSanApi.addChoThue(
      dataChoThue.DuongDanAnh,
      dataChoThue.HoTen,
      dataChoThue.SoDienThoai,
      dataChoThue.DiaChi,
      dataChoThue.CMND,
      dataChoThue.NgayMuon,
      dataChoThue.NgayTra,
      dataChoThue.NguoiTao,
      dataChoThue.KhachHang_GhiChu,
      dataChoThue.TaiSanId,
      dataChoThue.PhiThue,
      dataChoThue.TaiSan_GhiChu
    ).then((response) => {
      // showAlert();
      pushNotification(
        "Cho thuê tài sản thành công",
        "success",
        "TOP_CENTER",
        1000
      );
      props.onHide();
      dispatch(getListTaiSan(dataSearch));
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-cho-thue.png" />
          </span>{" "}
          Cho thuê
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse56"
                className="card-header"
                href="#collapse56"
                aria-expanded="true"
                aria-controls="collapse56"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thông tin khách hàng thuê tài sản</h3>
                </a>
              </div>
              <div
                id="collapse56"
                aria-labelledby="headingCollapse56"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="thong-tin-khach-vay">
                      <div className="row col-md-12">
                        <div
                          className="col-md-3"
                          style={{ marginRight: "-45px" }}
                        >
                          <div className="col-md-12 no-image1">
                            <div className="col-md-12">
                              <div>
                                <UploadCustomerImage
                                  onChange={onChangeImg()}
                                  image={dataChoThue.DuongDanAnh}
                                  Code={nameCode}
                                ></UploadCustomerImage>
                              </div>
                              <input
                                type="hidden"
                                name="customer.Img"
                                ref={register}
                                value={dataChoThue.DuongDanAnh}
                              ></input>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-9">
                          <div className="row">
                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                
                                labelText="Họ Tên"
                                inputProps={{
                                  name: "HoTen",
                                  // ref: NguoiNhan,
                                  onChange: updateTextValue("HoTen"),
                                  value: dataChoThue.HoTen,
                                }}
                              ></TextInputOnRow>
                              {errors.hoTen && (
                                <span className="canh-bao-red">
                                  {errors.hoTen}
                                </span>
                              )}
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Số điện thoại"
                                inputProps={{
                                  name: "SoDienThoai",
                                  onChange: updateTextValue("SoDienThoai"),
                                  value: dataChoThue.SoDienThoai,
                                }}
                              ></TextInputOnRow>
                              {errors1.soDienThoai && (
                                <span className="canh-bao-red">
                                  {errors1.soDienThoai}
                                </span>
                              )}
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Địa chỉ"
                                inputProps={{
                                  name: "DiaChi",
                                  onChange: updateTextValue("DiaChi"),
                                  value: dataChoThue.DiaChi,
                                }}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="CMND/PP/BLX"
                                inputProps={{
                                  name: "CMND",
                                  onChange: updateTextValue("CMND"),
                                  value: dataChoThue.CMND,
                                }}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="color7-bold">Ngày mượn</label>
                                <DateTimePicker
                                  value={convertDate(dataChoThue.NgayMuon)}
                                  name="NgayMuon"
                                  onChange={onChangeDate("NgayMuon")}
                                ></DateTimePicker>
                                {errors2.ngayMuon && (
                                  <span className="canh-bao-red">
                                    {errors2.ngayMuon}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className="color7-bold">Ngày trả</label>
                                <DateTimePicker
                                  value={convertDate(dataChoThue.NgayTra)}
                                  name="NgayTra"
                                  onChange={onChangeDate("NgayTra")}
                                ></DateTimePicker>
                                {errors3.ngayTra && (
                                  <span className="canh-bao-red">
                                    {errors3.ngayTra}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label
                                  for="projectinput1"
                                  className="color7-bold"
                                >
                                  Người tạo hợp đồng
                                </label>
                                <Controller
                                  control={control}
                                  name="NguoiGiaoDich"
                                  // rules={{ required: "Hãy chọn kho" }}
                                  render={({ onChange, onBlur, value }) => (
                                    <select
                                      // onChange={updateDropdown("KhoID")}
                                      onChange={(evt) => {
                                        onChange(evt);
                                        updateDropdown("NguoiTao")(evt);
                                      }}
                                      value={dataChoThue.NguoiTao}
                                      defaultValue={dataChoThue.NguoiTao}
                                      className="form-control input-sm"
                                    >
                                      {listUser &&
                                        listUser.map((item, idx) => (
                                          <option value={item.value}>
                                            {item.label}
                                          </option>
                                        ))}
                                    </select>
                                  )}
                                />
                                {errors5.nguoiTao && (
                                  <span className="canh-bao-red">
                                    {errors5.nguoiTao}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ paddingBottom: "10px" }}
                      >
                        <div className="form-group">
                          <label className="color7-bold">Ghi chú</label>
                          <textarea
                            rows="2"
                            style={{ minHeight: "80px" }}
                            className="form-control input-sm"
                            name="KhachHang_GhiChu"
                            value={dataChoThue.KhachHang_GhiChu}
                            onChange={updateTextValue("KhachHang_GhiChu")}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                style={{ paddingTop: "20px" }}
                className="card-header"
                href="#collapse191"
                aria-expanded="true"
                aria-controls="collapse191"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thông tin tài sản cho thuê</h3>
                </a>
              </div>
              <div
                id="collapse191"
                aria-labelledby="headingCollapse191"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Mã tài sản"
                              disabled=" disabled"
                              value={dataChoThue.Code}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Tên tài sản"
                              disabled=" disabled"
                              value={dataChoThue.TenTaiSan}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Kho"
                              disabled=" disabled"
                              value={dataChoThue.StoreName}
                            ></TextInputOnRow>
                          </div>

                          <div className="col-md-3">
                            <TextInputOnRow
                              labelClass="label-control color7-bold"
                              inputClass="form-control input-sm"
                              wrapperClass="form-group"
                              labelText="Phí thuê"
                              inputProps={{
                                name: "PhiThue",
                                // ref: TienThanhToan,
                                onChange: onChangeNumber("PhiThue"),
                                value: formatNumber(dataChoThue.PhiThue),
                              }}
                            ></TextInputOnRow>
                            {errors4.phiThue && (
                              <span className="canh-bao-red">
                                {errors4.phiThue}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <TextInputOnRow
                          labelClass="label-control color7-bold"
                          inputClass="form-control input-sm"
                          wrapperClass="form-group"
                          labelText="Trạng thái"
                          value={props.trangthai}
                          disabled=" disabled"
                        ></TextInputOnRow>
                      </div>

                      <div className="col-md-9">
                        <div className="form-group">
                          <label className="color7-bold">Ghi chú</label>
                          <textarea
                            rows="1"
                            className="form-control input-sm text-era"
                            name="TaiSan_GhiChu"
                            value={dataChoThue.TaiSan_GhiChu}
                            onChange={updateTextValue("TaiSan_GhiChu")}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSubmit}
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>{" "}
          &nbsp; Xác nhận&nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
